/**
 * Voluntary Life & AD&D Skeleton
 *
 * Provides the default structure for a Voluntary Life coverage.
 */

import {
  BaseBenefitPlanPolicyPeriod,
  BenefitPlanTypeEnum,
  CoverageTypeEnum,
  FundingTypeEnum,
  PlanOptionNameEnum,
  RfpBenefitPlan,
  RfpCoverage,
} from "../../types/rfp.api.types";

export const getVoluntaryLifeSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.VOLUNTARY_LIFE_ADND,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "voluntaryLifeAdnd-plan-1",
      name: "Voluntary Life & AD&D Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: BaseBenefitPlanPolicyPeriod.newBusiness,
      fundingType: FundingTypeEnum.NOT_APPLICABLE,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "voluntaryLifeAdnd",
        // Employee Benefits
        benefitDescriptionEmployeeType: undefined,
        benefitDescriptionEmployeeAmount: 0,
        benefitMaximumEmployeeType: undefined,
        benefitMaximumEmployeeDollarAmount: 0,
        benefitMaximumEmployeeSalaryMultiplier: 0,
        guaranteeIssueEmployeeType: undefined,
        guaranteeIssueEmployeeDollarAmount: 0,
        guaranteeIssueEmployeeSalaryMultiplier: undefined,
        guaranteeIssueEmployeeAdditionalAmount: undefined,
        guaranteeIssueEmployeeAgesDetails: [],
        // Spouse Benefits
        benefitDescriptionSpouseType: undefined,
        benefitDescriptionSpouseAmount: 0,
        benefitMaximumSpouseType: undefined,
        benefitMaximumSpouseAmount: 0,
        guaranteeIssueSpouseType: undefined,
        guaranteeIssueSpouseDollarAmount: 0,
        guaranteeIssueSpouseSalaryMultiplier: undefined,
        guaranteeIssueSpouseAdditionalAmount: undefined,
        guaranteeIssueSpouseAgesDetails: [],
        amountNotToExceedSpouseType: undefined,
        amountNotToExceedSpouseAmount: 0,
        // Child Benefits
        benefitDescriptionChildDependentAgesBirthTo14DaysType: undefined,
        benefitDescriptionChildDependentAgesBirthTo14DaysAmount: 0,
        benefitDescriptionChildDependentAges15DaysTo6MonthsType: undefined,
        benefitDescriptionChildDependentAges15DaysTo6MonthsAmount: 0,
        benefitDescriptionChildDependentAges6MonthsToLimitingAgeType: undefined,
        benefitDescriptionChildDependentAges6MonthsToLimitingAgeAmount: 0,
        childLimitingAge: undefined,
        benefitMaximumChildType: undefined,
        benefitMaximumChildAmount: 0,
        amountNotToExceedChildType: undefined,
        amountNotToExceedChildAmount: 0,
        studentStatusStudentLimitingAgeType: undefined,
        studentStatusStudentLimitingAgeAmount: undefined,
        // Definition of Earnings
        definitionOfEarningsType: undefined,
        definitionOfEarningsAverageMonths: 12,
        // Simple fields
        adndIncluded: undefined,
        adndTiedToLifeElection: "no",
        ageReductionScheduleType: undefined,
        ageReductionScheduleSchedules: [],
        conversion: undefined,
        acceleratedDeathBenefit: undefined,
        waiverOfPremium: undefined,
        annualOpenEnrollment: undefined,
        portability: undefined,
        // Extended (non-v5) fields — CD-2071
        eligibilityHours: undefined,
        suicideExclusion: undefined,
        waiverOfPremiumEligibility: undefined,
        waiverOfPremiumWaitingPeriod: undefined,
        waiverOfPremiumDuration: undefined,
        airBag: undefined,
        commonCarrier: undefined,
        repatriation: undefined,
        seatBelt: undefined,
        annualAbilityToIncreaseBenefit: undefined,
        spouseAgeBasisEeOrSpAge: undefined,
        ageReductionsEe: undefined,
        ageReductionsSp: undefined,
        employeeAgeReductionSchedules: undefined,
        spouseAgeReductionSchedules: undefined,
      },
    } as RfpBenefitPlan,
  ],
});
